<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">待出院列表</div>
				<div class="titleR">
					
				</div>
			</div>
			<div class="content">
				<div class="con">
					<!-- <div class="tabLine">
						<div class="tabLineL">
							
						</div>
						<div class="tabLineR">
							
						</div>
					</div>
					<div class="searchLine">
						<div class="searchLineL">
							
						</div>
						<div class="searchLineR"></div>
					</div> -->
					<div class="elTable">
						<el-table :data="tableData" style="width: 100%" height="100%">
							<el-table-column label="单号" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.id}}</div>
								</template>
							</el-table-column>
							<el-table-column label="顾客" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.memberName}}</div>
								</template>
							</el-table-column>
							<el-table-column label="手机号" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.memberMobile}}</div>
								</template>
							</el-table-column>
							<el-table-column label="宠物" min-width="50">
								<template slot-scope="props">
									{{props.row.petName}} |
									{{props.row.typeName}} |
									{{props.row.sex}} |
									{{props.row.birthDay&&props.row.birthDay.length>4?($public.FAge(new Date(props.row.birthDay).getTime())[0]+'岁'+$public.FAge(new Date(props.row.birthDay).getTime())[1]+'月'):''}}
								</template>
							</el-table-column>
							<el-table-column label="经办人" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.handlerName}}</div>
								</template>
							</el-table-column>
							<el-table-column label="截止时间" min-width="50">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.beginDate,'YYYY/MM/DD')}}-{{$public.FTime(props.row.endDate,'YYYY/MM/DD')}}</div>
								</template>
							</el-table-column>
							<el-table-column label="时长" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.inHospitalDuration}}</div>
								</template>
							</el-table-column>
							<el-table-column label="住院情况" min-width="50">
								<template slot-scope="props">
									<div v-if="props.row.payInfo.payCount===0">
										<div style="color:red">未支付</div>
									</div>
									<div v-else>
										<div style="color:#18A44C">{{props.row.status==1?'住院中':''}}</div>
										<div style="color:#B7B7B7">{{props.row.status==2?'已离院':''}}</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="状态" min-width="50">
								<template slot-scope="props">
									<span v-if="props.row.consumeMoney>props.row.deposit" style="color:red">已欠费</span>
									<span v-else>
										<span v-if="props.row.payInfo&&props.row.payInfo.payCount==0" style="color:#B05B12">{{props.row.payInfo.payCount}}/{{props.row.payInfo.total}}</span>
										<span v-if="props.row.payInfo&&props.row.payInfo.payCount>0" style="color:#18A44C">{{props.row.payInfo.payCount}}/{{props.row.payInfo.total}}</span>
									</span>
								</template>
							</el-table-column>
							<el-table-column label="操作" min-width="50">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="see_zhuyuan(props.row)">查看</el-button>
									<el-button
									v-show="$buttonAuthority('yewu-yiliaoxin-editzhuyuan')"
									v-if="props.row.status==1"
									type="text" @click="edit_zhuyuan(props.row)" size="mini">编辑</el-button>
									<el-button
									v-show="$buttonAuthority('yewu-yiliaoxin-delzhuyuan')"
									v-if="props.row.status!=2"
									type="text" @click="del_zhuyuan(props.row)" size="mini">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="pageBox">
					<page style="padding:10px 0;" :total="page.total" :page="page.page" @change="changePage"></page>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
			}
		},
		computed:{
			loginInfo(){
				return this.$store.state.userInfo
			},
			rightZhuyuanParams(){
				return this.$store.state.yiliaoxin.rightZhuyuanParams
			}
		},
		created(){
			
		},
		mounted(){
			this.page = this.rightZhuyuanParams.initialDataOflist.page||this.page;
			this.getTableData();
		},
		methods: {
			see_zhuyuan(row){
				let obj = this.$store.state.yiliaoxin.zhuyuanParams
				obj.curRow = row
				obj.type = 'see'
				this.$store.commit("yiliaoxin/set_zhuyuanParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'住院')
				this.$store.commit("yiliaoxin/add_router",{name:'住院',data:obj})
			},
			edit_zhuyuan(row){
				let obj = this.$store.state.yiliaoxin.zhuyuanParams
				obj.curRow = row
				obj.type = 'edit'
				this.$store.commit("yiliaoxin/set_zhuyuanParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'住院')
				this.$store.commit("yiliaoxin/add_router",{name:'住院',data:obj})
			},
			del_zhuyuan(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete('/api/InHospital/Delete', {inHospitalId:row.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let params = {
					"petId": '',
					"status": 1, // 0不限；1：住院中；2：已离院
					isPay:-1,  // （-1不限：0未支付；1：已支付）
					"depositType": 0,  // (0不限；1：押金；2：余额)
					"startTime": "",
					"endTime": "",
					"desc": true,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword":'',
					createUserId:this.loginInfo.uid,
				}
				let loading=this.$loading();
				this.$http.post('/api/InHospital/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			replaceRouter(){
				this.rightZhuyuanParams.initialDataOflist = {
					page:JSON.parse(JSON.stringify(this.page)),
				}
				this.$store.commit("yiliaoxin/set_rightZhuyuanParams",JSON.parse(JSON.stringify(this.rightZhuyuanParams)))
				this.$store.commit("yiliaoxin/replace_router",{name:'rZhuyuan',data:JSON.parse(JSON.stringify(this.rightZhuyuanParams))})
			},
		},
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				position: relative;display: flex;padding:0px 0 50px;width:100%;height: calc(100% - 47px);box-sizing: border-box;
				.con{
					width:100%;
					.tabLine{
						height:60px;padding:16px 20px 12px;box-sizing: border-box;display: flex;justify-content: space-between;
						.tabLineL{
							display: flex;
							.tabItem{
								width:90px;text-align: center;line-height: 32px;border-radius: 19px;background-color: #f7f7f7;color:#73737B;font-size: 14px;margin-right: 20px;border:1px solid transparent;cursor: pointer;
								font-weight: bold;
								&.active{
									color:$mainColor;background-color: #FFF9F3;border-color:$mainColor;
								}
							}
						}
						.tabLineR{
							
						}
					}
					.searchLine{
						padding:8px 20px 20px;box-sizing: border-box;display: flex;
						.searchLineL{
							display: flex;
							.searchLabel{
								font-size: 14px;margin-right: 5px;color:$fontColor;line-height:32px;margin-left:10px;
							}
						}
						.searchLineR{
							
						}
					}
					.elTable{
						height: calc(100% - 121px);
					}
				}
				.pageBox{
					position: absolute;bottom:0;width:100%;
				}
			}
		}
	}
</style>
